import { combineReducers } from "redux";
import appsetup from "../features/admin/setting/appsetup/Slice";


const setting = combineReducers({
  appsetup: appsetup,
});

export default setting;
